import { CommonModule } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subject, takeUntil, tap } from 'rxjs';

import { ToastService, ToastType } from '../../services/toast-message.service';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { TOAST_CONFIG } from './toast.config';

@Component({
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrl: './toast-message.component.scss',
  imports: [CommonModule, SvgIconComponent],
})
export class ToastMessageComponent implements OnInit, OnDestroy {
  @ViewChild(TemplateRef, { static: false }) template?: TemplateRef<any>;

  ToastType = ToastType;

  private destroy$ = new Subject<void>();

  constructor(
    private toastService: ToastService,
    private notification: NzNotificationService,
  ) {}

  ngOnInit(): void {
    this.toastService.toast$
      .pipe(
        tap(({ type, message, duration }) => {
          this.notification.template(this.template, {
            nzData: { type, message },
            nzDuration: duration ?? 3000,
            nzPauseOnHover: true,
            nzPlacement: 'bottom',
            nzAnimate: true,
          });
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  configData(type: ToastType) {
    return TOAST_CONFIG[type];
  }
}
